// Données fictives pour le site Soleil d'Azur

// Formules Réseaux Sociaux
export const mockPlans = [
  {
    id: 1,
    name: "Débutant",
    price: "€550",
    period: "par mois",
    description: "Parfait pour les petites entreprises qui débutent avec une communication professionnelle.",
    features: [
      "Gestion des réseaux sociaux standard",
      "12 vidéos courtes par mois",
      "6 publications par mois"
    ],
    popular: false,
    color: "border-gray-200"
  },
  {
    id: 2,
    name: "Professionnel",
    price: "€950",
    period: "par mois",
    description: "Solutions de communication complètes pour les entreprises en croissance.",
    features: [
      "20 vidéos courtes",
      "10 publications",
      "2 créations print",
      "1 analyse concurrentielle"
    ],
    popular: true,
    color: "border-amber-400"
  },
  {
    id: 3,
    name: "Entreprise",
    price: "€1 200",
    period: "par mois",
    description: "Solutions de communication complètes pour les entreprises établies.",
    features: [
      "30 vidéos courtes",
      "20 publications",
      "5 créations print",
      "SEO sur site",
      "Développement de marque",
      "Analyse concurrentielle",
      "Gestion d'événements",
      "Partenariats + promotion sur nos canaux"
    ],
    popular: false,
    color: "border-gray-200"
  }
];

// Formules Site Web
export const mockWebPackages = [
  {
    id: 1,
    name: "Site Vitrine",
    price: "1 200€",
    description: "Solution idéale pour présenter votre activité avec une présence web professionnelle.",
    features: [
      "1 page vitrine complète",
      "Page contact intégrée",
      "SEO optimisé",
      "Design personnalisé",
      "1 vidéo gratuite offerte",
      "Photos professionnelles incluses"
    ],
    color: "border-blue-400",
    accentColor: "from-blue-600 to-indigo-600",
    popular: false
  },
  {
    id: 2,
    name: "Site Élaboré",
    price: "1 600€",
    description: "Site web complet avec toutes les pages essentielles pour développer votre activité.",
    features: [
      "2 à 5 pages personnalisées",
      "Page contact ou réservation",
      "Page à propos",
      "Page équipe",
      "Page services ou produits",
      "Photos professionnelles incluses",
      "1 vidéo gratuite offerte",
      "SEO optimisé par IA",
      "Optimisation client",
      "Conseil en communication"
    ],
    color: "border-amber-400",
    accentColor: "from-amber-600 to-orange-600",
    popular: true
  },
  {
    id: 3,
    name: "Site E-commerce",
    price: "Sur devis",
    description: "Solution e-commerce complète pour vendre en ligne avec stratégie d'acquisition client.",
    features: [
      "Page vitrine",
      "Page contact",
      "Page nos produits",
      "Pages produits optimisées pour la vente",
      "Page de paiement sécurisée",
      "Entonnoir d'acquisition client",
      "SEO optimisé par IA"
    ],
    color: "border-green-400",
    accentColor: "from-green-600 to-teal-600",
    popular: false
  }
];

export const mockResources = [
  {
    id: 1,
    title: "Guide Stratégie de Marque 2024",
    description: "Un guide complet pour développer une stratégie de marque gagnante dans le marché concurrentiel d'aujourd'hui.",
    fileType: "PDF",
    size: "2,5 Mo",
    downloadCount: 1250,
    category: "Stratégie",
    thumbnail: "/api/placeholder/400/300",
    uploadDate: "2024-01-15"
  },
  {
    id: 2,
    title: "Liste de Contrôle Marketing Digital",
    description: "Liste de contrôle essentielle pour planifier et exécuter des campagnes marketing digital réussies.",
    fileType: "PDF",
    size: "1,8 Mo",
    downloadCount: 980,
    category: "Marketing",
    thumbnail: "/api/placeholder/400/300",
    uploadDate: "2024-01-20"
  },
  {
    id: 3,
    title: "Pack Modèles Réseaux Sociaux",
    description: "Modèles professionnels pour créer du contenu engageant sur toutes les plateformes de réseaux sociaux.",
    fileType: "ZIP",
    size: "15,2 Mo",
    downloadCount: 2100,
    category: "Design",
    thumbnail: "/api/placeholder/400/300",
    uploadDate: "2024-02-01"
  },
  {
    id: 4,
    title: "Tendances Design Web 2024",
    description: "Dernières tendances et meilleures pratiques pour un design web moderne qui convertit.",
    fileType: "PDF",
    size: "4,1 Mo",
    downloadCount: 1680,
    category: "Design",
    thumbnail: "/api/placeholder/400/300",
    uploadDate: "2024-02-10"
  },
  {
    id: 5,
    title: "Boîte à Outils Création de Contenu",
    description: "Tout ce dont vous avez besoin pour créer du contenu convaincant qui engage votre audience.",
    fileType: "ZIP",
    size: "8,7 Mo",
    downloadCount: 1420,
    category: "Contenu",
    thumbnail: "/api/placeholder/400/300",
    uploadDate: "2024-02-15"
  },
  {
    id: 6,
    title: "Manuel Optimisation SEO",
    description: "Guide étape par étape pour optimiser votre site web pour les moteurs de recherche et améliorer votre classement.",
    fileType: "PDF",
    size: "3,2 Mo",
    downloadCount: 1890,
    category: "SEO",
    thumbnail: "/api/placeholder/400/300",
    uploadDate: "2024-02-20"
  }
];

export const mockContactSubmissions = [
  {
    id: 1,
    firstName: "Jean",
    lastName: "Dupont",
    email: "jean.dupont@example.com",
    phone: "+33 6 12 34 56 78",
    subject: "Demande de projet",
    message: "Je suis intéressé par votre formule professionnelle pour mon entreprise en croissance. Pourrions-nous planifier une consultation ?",
    submittedAt: "2024-02-25T10:30:00Z",
    status: "en_attente"
  },
  {
    id: 2,
    firstName: "Marie",
    lastName: "Martin",
    email: "marie.martin@example.com",
    phone: "+33 6 98 76 54 32",
    subject: "Consultation Stratégie de Marque",
    message: "Nous avons besoin d'aide pour développer notre stratégie de marque. Notre entreprise lance une nouvelle gamme de produits.",
    submittedAt: "2024-02-24T14:15:00Z",
    status: "contacté"
  }
];

export const mockTeamMembers = [
  {
    id: 1,
    name: "Quentin Brunet",
    role: "Associé & Directeur Créatif",
    specialties: "Graphisme, vidéo, web, IA",
    email: "quentin@soleil-azur.com",
    bio: "Expert en création visuelle avec plus de 8 ans d'expérience dans les domaines du graphisme, de la vidéo, du développement web et de l'intelligence artificielle. Il dirige notre vision créative et assure l'innovation dans tous nos projets.",
    avatar: "/api/placeholder/150/150",
    linkedin: "https://linkedin.com/in/quentin-brunet",
    joinDate: "2024-01-15"
  },
  {
    id: 2,
    name: "Alexcia Demus",
    role: "Associée, Designer Commercial, Directrice Artistique",
    specialties: "Responsable Partenariats",
    email: "alexcia@soleil-azur.com",
    bio: "Créatrice passionnée spécialisée dans le design commercial et la direction artistique. Elle développe nos partenariats stratégiques et crée des solutions visuelles qui génèrent des résultats commerciaux concrets.",
    avatar: "/api/placeholder/150/150",
    linkedin: "https://linkedin.com/in/alexcia-demus",
    joinDate: "2024-01-15"
  }
];

export const mockServices = [
  {
    id: 1,
    name: "Stratégie de Marque",
    description: "Développez des identités de marque convaincantes qui résonnent avec votre audience cible et stimulent la croissance de votre entreprise.",
    icon: "target",
    features: ["Positionnement de marque", "Étude de marché", "Analyse concurrentielle", "Guidelines de marque"]
  },
  {
    id: 2,
    name: "Création Visuelle",
    description: "Transformez votre vision en expériences visuelles époustouflantes qui captivent et inspirent vos clients.",
    icon: "lightbulb",
    features: ["Design logo", "Identité visuelle", "Supports print", "Design packaging"]
  },
  {
    id: 3,
    name: "Marketing Digital",
    description: "Connectez-vous avec votre audience grâce à des campagnes digitales stratégiques qui offrent des résultats mesurables.",
    icon: "users",
    features: ["Gestion réseaux sociaux", "Publicité PPC", "Email marketing", "Rapports analytiques"]
  },
  {
    id: 4,
    name: "Développement Web",
    description: "Créez des sites web responsives et conviviaux qui convertissent les visiteurs en clients.",
    icon: "globe",
    features: ["Design responsive", "Intégration CMS", "Solutions e-commerce", "Optimisation SEO"]
  },
  {
    id: 5,
    name: "Création de Contenu",
    description: "Créez du contenu engageant qui raconte l'histoire de votre marque et connecte avec votre audience.",
    icon: "edit",
    features: ["Rédaction", "Photographie", "Production vidéo", "Stratégie de contenu"]
  },
  {
    id: 6,
    name: "Conseil",
    description: "Guidance stratégique pour aider votre entreprise à naviguer dans le monde complexe de la communication moderne.",
    icon: "chart",
    features: ["Développement stratégique", "Analyse de marché", "Optimisation des performances", "Ateliers de formation"]
  }
];

// Helpers pour la persistance des données dans localStorage
export const saveToLocalStorage = (key, data) => {
  try {
    localStorage.setItem(key, JSON.stringify(data));
  } catch (error) {
    console.error('Erreur lors de la sauvegarde dans localStorage:', error);
  }
};

export const loadFromLocalStorage = (key, defaultData) => {
  try {
    const saved = localStorage.getItem(key);
    return saved ? JSON.parse(saved) : defaultData;
  } catch (error) {
    console.error('Erreur lors du chargement depuis localStorage:', error);
    return defaultData;
  }
};

// Initialiser localStorage avec les données fictives
export const initializeMockData = () => {
  saveToLocalStorage('soleil_contact_submissions', mockContactSubmissions);
  saveToLocalStorage('soleil_resources', mockResources);
  saveToLocalStorage('soleil_plans', mockPlans);
  saveToLocalStorage('soleil_web_packages', mockWebPackages);
};
